/// <amd-module name="VSS/Platform/Util/Debug" />

if ($DEBUG) {
    const error = console.error;

    console.error = function() {
        // Eat certain messages we dont want shown to the user, we understand the warnings and except them.
        if (arguments && arguments[0] && arguments[0].indexOf) {
            // This warning is thrown by react if there is something other than a <tr> as a child of a <tbody>.
            // We use <a>'s instead of <tr>'s to make the entire row a hyperlink.
            // We use <div>'s instead of <tr>'s for our row overlays.
            if (
                arguments[0].indexOf("Warning: validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s%s") === 0 &&
                (((arguments[1] === "<a>" || arguments[1] === "<div>") && arguments[2] === "tbody") ||
                    (arguments[1] === "<td>" && arguments[2] === "a"))
            ) {
                return;
            }

            if (error) {
                // @ts-ignore don't use `arguments` - prefer ...rest parameters.
                error.apply(this, arguments);
            }
        }
    };
}
